import {checkOrgNameAvailability} from '~/utils/checkOrgNameAvailability';

// "sam@sentra.io" -> "Sentra"; falls back to "Workspace" when there is no domain.
export const deriveOrgNameFromEmail = (email: string | null | undefined): string => {
  const at = (email ?? '').indexOf('@');
  const domain = at >= 0 ? (email ?? '').slice(at + 1) : '';
  const base = (domain.split('.')[0] ?? '').trim();
  if (!base) return 'Workspace';
  return base.charAt(0).toUpperCase() + base.slice(1);
};

// Walk base, base_1, base_2, ... until /orgs/check-name says it's free.
// Falls back to a random suffix after 99 attempts so we always return.
export const findAvailableOrgName = async (apiBaseUrl: string, base: string): Promise<string> => {
  const initial = await checkOrgNameAvailability(apiBaseUrl, base);
  if (initial !== 'taken') return base;
  for (let i = 1; i <= 99; i += 1) {
    const candidate = `${base}_${i}`;
    const state = await checkOrgNameAvailability(apiBaseUrl, candidate);
    if (state !== 'taken') return candidate;
  }
  return `${base}_${Math.random().toString(36).slice(2, 6)}`;
};
